import { ConnectDeviceSummarySchema } from "@rakazo/contracts";
import { useEffect, useState } from "react";
import { fetchAuthCapabilities } from "./auth-capabilities";
import { connectRequest } from "./connect";

/** Connect is offered only when this server announces it; a failed lookup keeps it hidden. */
export function useConnectAvailable() {
  const [available, setAvailable] = useState(false);
  useEffect(() => {
    let current = true;
    void fetchAuthCapabilities().then(
      (capabilities) => {
        if (current) setAvailable(capabilities.connect === true);
      },
      () => undefined,
    );
    return () => {
      current = false;
    };
  }, []);
  return available;
}

/**
 * How many of the workspace's paired computers are active right now, read again each time `watch`
 * turns on (the account menu opening); null until known or when the list cannot be read.
 */
export function useActiveConnectComputers(spaceId: string | null, watch: boolean) {
  const [active, setActive] = useState<number | null>(null);
  useEffect(() => {
    if (!watch || !spaceId) return;
    const abort = new AbortController();
    connectRequest("list", { spaceId }, abort.signal).then(
      (rows) => {
        const devices = ConnectDeviceSummarySchema.array().safeParse(rows);
        setActive(
          devices.success
            ? devices.data.filter((device) => device.state === "active").length
            : null,
        );
      },
      () => {
        if (!abort.signal.aborted) setActive(null);
      },
    );
    return () => abort.abort();
  }, [spaceId, watch]);
  return active;
}
